/*
 * utils.ts
 *
 * All utilities class.
 */
import { mcUtilsAxios } from 'src/utils/utils.axios';
import { mcUtilsCommon } from 'src/utils/utils.common';
import { mcUtilsPdfmake } from 'src/utils/utils.pdfmake';
import { mcUtilsQuasarDate } from 'src/utils/utils.quasar.date';
import { mcUtilsQuasarDialog } from 'src/utils/utils.quasar.dialog';
import { mcUtilsQuasarNotify } from 'src/utils/utils.quasar.notify';
import { mcUtilsRuleQinput } from 'src/utils/utils.rule.qinput';
//
export class mcUtils {
  public static cpsoAxios: mcUtilsAxios = new mcUtilsAxios();
  public static cpsoCommon: mcUtilsCommon = new mcUtilsCommon();
  public static cpsoPdfmake: mcUtilsPdfmake = new mcUtilsPdfmake();
  public static cpsoQuasarDate: mcUtilsQuasarDate = new mcUtilsQuasarDate();
  public static cpsoQuasarDialog: mcUtilsQuasarDialog = new mcUtilsQuasarDialog();
  public static cpsoQuasarNotify: mcUtilsQuasarNotify = new mcUtilsQuasarNotify();
  public static cpsoRuleQinput: mcUtilsRuleQinput = new mcUtilsRuleQinput();
}
//#end#
